require('./hireAdvancedInterstitialPromotion.scss');
require('./hireAdvancedInterstitialPromotions.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @ helpers
const {
    FormattedText,
    formatText
} = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// constants
const { PROMOTION_SET_CODE } = require('constants/operationTypes');

class HireAdvancedInterstitialPromotion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkboxTermsValue: false,
        };
        this.handleCheckboxTermsChange = this.handleCheckboxTermsChange.bind(this);
    }

    handleCheckboxTermsChange(evt) {
        this.setState({
            checkboxTermsValue: evt.target.checked
        });
    }

    buildSignaturePatternSection() {
        const { checkboxTermsValue } = this.state;
        const operationParams = {};
        let dataToRender = null;
        if (checkboxTermsValue) {
            dataToRender = (
                <SignaturePattern
                    operationType={PROMOTION_SET_CODE}
                    operationParams={operationParams}
                />
            );
        }
        return dataToRender;
    }

    render() {
        const { immPromotions, immAdvancedInterstitialPromotions, onCancel, onFinish } = this.props;
        const { checkboxTermsValue } = this.state;
        const buildSignaturePatternSection = this.buildSignaturePatternSection();
        const isSettingPromotion = immPromotions.get('isSettingPromotion');
        const immHirePromotions = immAdvancedInterstitialPromotions.get('promotions');
        const inputPromotionValue = immHirePromotions.get('promoCode');
        const immPromotion = immPromotions.getIn(['byId', inputPromotionValue]);
        const previewTitle = immPromotion.get('title');
        const previewSubTitle = immPromotion.get('subtitle');
        const previewUrlImg = immPromotion.get('urlImg');
        const promotionName = immHirePromotions.get('description');
        const viewDetailLinkUrl = immHirePromotions.get('promoURL');
        const previewUrlTerms = immPromotion.get('url');
        const viewDetailTarget = __CONTACT_CENTER__ ? "_blank" : '';
        const promotionNid = immAdvancedInterstitialPromotions.getIn(['promotions', 'nid']);
        const previewCheckboxLabel = (
            <div className="hire-advanced-interstitial-promotion__preview-terms">
                <FormattedText value="hireAdvancedInterstitialPromotion-hireAdvancedInterstitialPromotion_termsPromotionPreview" />
                <OKLink modifier="emphasize" extraClass="hire-advanced-interstitial-promotion__preview-terms-link"
                    to={previewUrlTerms}
                    target="_blank"
                    onClick={() => recordLink(promotionNid, formatText('hireAdvancedInterstitialPromotion-hireAdvancedInterstitialPromotion_termsLinkPromotionPreview'))}
                >
                    <FormattedText value="hireAdvancedInterstitialPromotion-hireAdvancedInterstitialPromotion_termsLinkPromotionPreview" />
                </OKLink>
            </div>
        );
        return (
            <OKSectionBox>
                <div className="hire-advanced-interstitial-promotion__title">
                    <HTMLSafeInjector
                        message={promotionName}
                    />
                </div>
                <section id="printable-wizard" className="hire-advanced-interstitial-promotion__content">
                    <section className="hire-advanced-interstitial-promotion__preview-content">
                        <div className="row hire-advanced-interstitial-promotion__preview-container">
                            <div className="col-xs-4">
                                <img className="hire-advanced-interstitial-promotion__preview-image" src={previewUrlImg} />
                            </div>
                            <div className="col-xs-8">
                                <div className="hire-advanced-interstitial-promotion__preview-title">
                                    {previewTitle}
                                </div>
                                <span className="ok-box-title__separator"></span>
                                <div className="hire-advanced-interstitial-promotion__preview-subtitle">
                                    {previewSubTitle}
                                </div>
                                <div classsName="hire-advanced-interstitial-promotion__view-detail-link">
                                    <OKLink
                                        modifier="editorial"
                                        to={viewDetailLinkUrl}
                                        target={viewDetailTarget}
                                        onClick={() => recordLink(promotionNid, formatText('hireAdvancedInterstitialPromotion-hireAdvancedInterstitialPromotion__viewDetailLink'))}
                                    >
                                        <FormattedText value="hireAdvancedInterstitialPromotion-hireAdvancedInterstitialPromotion__viewDetailLink" />
                                    </OKLink>
                                </div>
                            </div>
                        </div>
                        <footer className="hire-advanced-interstitial-promotion__preview-footer">
                            <OKCheckbox idName="chkPreviewPromotion"
                                label={previewCheckboxLabel}
                                value={checkboxTermsValue}
                                onChange={this.handleCheckboxTermsChange}
                            />
                        </footer>
                        <div className="hire-advanced-interstitial-promotion__continue-link">
                            <OKLink
                                modifier="ghost"
                                to="/myprofile/edit"
                                onClick={() => recordLink(promotionNid, formatText('availPromotionSuccessStep-availPromotionSuccessStep_secondaryCTAText'))}
                            >
                                <FormattedText value="availPromotionSuccessStep-availPromotionSuccessStep_secondaryCTAText" />
                            </OKLink>
                        </div>
                    </section>
                    <div className="hire-advanced-interstitial-promotion__signature-pattern">
                        {buildSignaturePatternSection}
                    </div>
                </section>
                <footer className="hire-advanced-interstitial-promotion__buttons">
                    <div className="hire-advanced-interstitial-promotion__cancel-button">
                        <OKButton id="btnCancelPromotion"
                            modifier="link-ghost"
                            onClick={() => (
                                onCancel,
                                recordLink(promotionNid, formatText('promotions-cancelButton'))
                            )}
                        >
                            <FormattedText value="promotions-cancelButton" />
                        </OKButton>
                    </div>
                    <div className="hire-advanced-interstitial-promotion__finish-button">
                        <OKButton id="btnClaimPromotion"
                            disabled={!checkboxTermsValue}
                            onClick={() => (
                                onFinish(inputPromotionValue),
                                recordLink(promotionNid, formatText('promotions-finishButton'))
                            )}
                            loading={isSettingPromotion}
                        >
                            <FormattedText value="promotions-finishButton" />
                        </OKButton>
                    </div>
                </footer>
            </OKSectionBox>

        );
    }
}

HireAdvancedInterstitialPromotion.propTypes = {
    immAdvancedInterstitialPromotions: PropTypes.object.isRequired,
    immPromotions: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
};

module.exports = HireAdvancedInterstitialPromotion;
